<template>
    <div class="add-graph uk-card uk-card-default uk-margin-bottom">
        <div class="graph-info uk-padding-small uk-flex">
            <img class="uk-margin-small-right" :src="require('@/assets/images/icons/icon-graph.png')" alt="" />
            <div class="uk-text-middle">
                <p class="uk-margin-remove uk-text-bolder">{{ graph.name }}</p>
                <p class="uk-margin-remove uk-text-muted uk-text-small">{{ graph.title }}</p>
            </div>

            <button
                class="uk-icon-button uk-border-circle pointer"
                :class="moreInfo ? 'rotate-225' : 'rotate-90'"
                @click="toggleMoreInfo"
            ></button>
        </div>

        <div v-if="moreInfo" class="graph-example uk-padding-small uk-text-right">
            <img
                class="uk-margin-small-bottom uk-margin-auto-left uk-margin-auto-right"
                :src="require('@/assets/images/graph-image.png')"
                alt="Image of corresponding graph"
            />
            <button class="uk-button-primary uk-button-small uk-text-light uk-border-rounded pointer" @click="addGraph">
                >Add Graph
            </button>
        </div>
    </div>
</template>

<script lang="js">
import Vue from "vue";

export default Vue.extend({
    name: "AddGraphContainer",
    props: {
        graph: {
            required: true,
            type: Object,
        },
        graphPosition: {
            required: false,
            type: Number,
        },
    },
    data() {
        return {
            moreInfo: false,
        };
    },
    methods: {
        toggleMoreInfo() {
            this.moreInfo = !this.moreInfo;
        },
        addGraph() {
            const graph = this.graph;
            const position = this.graphPosition;

            this.$store.dispatch("graphs/addGraph", { graph, position });

            this.$addGraphMenu.hide();
        },
    },
});
</script>
